module.exports = __webpack_public_path__ + "svg/social-facebook.svg?b9deb700c271e17972536c09c8392549";